<template>
    <main class="c-main">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <header class="card-header">
                        <router-link
                            :to="{ name: 'categoryStore' }"
                            class="btn btn-success"
                            >Добавить категорию</router-link
                        >
                        <h4 class="pull-right">Катеория</h4>
                    </header>
                    <div class="card-body">
                        <table
                            class="table table-bordered table-striped"
                            id="serverDataTable"
                        >
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>titleRus</th>
                                    <!-- <th>titleUzl</th>
                                    <th>titleUzk</th>
                                    <th>version</th> -->
                                    <th>Код</th>
                                    <th>Категория</th>
                                    <th>Кол Продуктов</th>
                                    <th>Действие</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(category, index) in categories"
                                    :key="index"
                                >
                                    <td>{{ category.id }} </td>
                                    <td>{{ category.title }}</td>
                                    <!-- <td>{{ category.titleUzl }}</td>
                                    <td>{{ category.titleUzk }}</td>
                                    <td>{{ category.version }}</td> -->
                                    <td>{{ category.code }}</td>
                                    <td>{{ category.parent == null ? "Основная категория" : category.parent.title }}</td>
                                    <td>{{ category.products_count }}</td>
                                    <td>
                                        <router-link
                                            class="btn btn-success"
                                            :to="{
                                                name: 'productsByCategory',
                                                params: {
                                                    category_id: category.id
                                                }
                                            }"
                                            >+ Продукт</router-link
                                        >
                                        <router-link
                                            class="btn btn-warning"
                                            :to="{
                                                name: 'categoryUpdate',
                                                params: {
                                                    category_id: category.id
                                                }
                                            }"
                                        >Изменить</router-link>
                                        <a
                                            href="javascript:void(0);"
                                            @click="deleteCategory(category.id)"
                                            class="btn btn-danger"
                                        >Удалить</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { GET, DELETE } from "../../shared/api";
export default {
    data() {
        return {
            categories: []
        };
    },
    methods: {
        getCategories() {
            GET([], "/category", this, false).then(response => {
                this.categories = response;
            });
        },
        deleteCategory(id) {
            DELETE(id, "/category/", this).then(response => {
                this.getCategories();
            });
        }
    },
    mounted() {
        this.getCategories();
    }
};
</script>
